import {axios} from '@/_metronic/helpers/network/Axios'
import {AskRequest} from './_models'

const CHAT_URL = '/report-services/chat'

const askLuwie = (body: AskRequest): Promise<any> => {
  return axios.post(CHAT_URL, body).then((d: any) => d.data)
}

export {askLuwie}
